import { ReactComponent as MaxSvg } from '../../assets/icons/max.svg';

export const MaxIcon: SvgIcon = (props) => {
    return <MaxSvg {...props} />;
};
